import {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useMediaQuery} from '@mui/material'
import ButtonDateTimeslotAtom from '../@atoms/to_forms/button_date_timeslot/button_date_timeslot_atom'
import {RootState} from '../store_redux'
import {
  BookingRequestPayload,
  BookingWindowResponseProps,
  BookVisitDatePayload,
} from '../props_reusable/visit'
import useError from './use_error'
import {showStandardDateChoiceModal} from '../store_redux/reducer/modal.reducer'
import visitService from '../services/visit.service'

const useBestDate = () => {
  const rootState = useSelector((state: RootState) => state)
  const {labels, modal} = rootState
  const dispatch = useDispatch()
  const [bestDates, setBestDates] = useState<BookingWindowResponseProps | null>(
    null,
  )
  const {bookedSlotDetail} = modal.data.bestDate
  const matches = useMediaQuery('(max-width:501px)')
  const {error, setError} = useError()

  type ButtonSlotHandle = React.ElementRef<typeof ButtonDateTimeslotAtom>
  const ref = useRef<ButtonSlotHandle>(null) // Pass the ref to get the child state

  const {subtitle, description, buttonAllSlots, buttonForErrorClose} =
    labels?.bookDateModal || {}

  const handleAllSlots = () => {
    dispatch(
      showStandardDateChoiceModal({
        ...modal.data.bestDate,
      }),
    )
  }

  const handleBookingWindowsError = (err: Error) => {
    if (err.message === '404') {
      handleAllSlots()
    } else {
      setError('getBookingWindows', err.message)
    }
  }

  useEffect(
    () => {
      if (bestDates && bookedSlotDetail)
        ref.current?.setDefaultValue(bookedSlotDetail)
    },
    // eslint-disable-next-line
    [bestDates],
  )

  useEffect(() => {
    const payload: BookingRequestPayload = {
      ReturnEco: true,
      VisitNum: modal.data.bestDate.visitId || 0,
    }
    visitService
      .getBookingDates<BookingWindowResponseProps>(payload)
      .then(setBestDates)
      .catch(handleBookingWindowsError)
    // eslint-disable-next-line
  }, [])

  const getBookVisitPayload = () => {
    const selectedDateTimeSlot = ref.current?.getSlot()
    return {
      ...bestDates?.bookingWindowSummaryData,
      visitNumber: modal.data.bestDate.visitId,
      visitDate: selectedDateTimeSlot?.date || '',
      timeSlot: selectedDateTimeSlot?.timeSlotId || 0,
      timeSlotGroup: selectedDateTimeSlot?.timeSlotGroupId || 0,
    } as BookVisitDatePayload
  }

  return {
    subtitle,
    description,
    matches,
    ref,
    bestDates,
    handleAllSlots,
    buttonAllSlots,
    buttonForErrorClose,
    error,
    setError,
    getBookVisitPayload,
  }
}

export default useBestDate
